import { z } from 'zod'

/**
 * Regular expression pattern to detect common XSS attack vectors.
 * Matches: <script, </script, javascript:, on[event]=, <iframe, <object, <embed
 */
export const XSS_PATTERN =
  /(<script|<\/script|javascript:|on\w+=|<iframe|<object|<embed)/i

/**
 * Checks if a string is free of common XSS patterns.
 * Use as a zod refinement function.
 *
 * @example
 * z.string().refine(noXssPatterns, { message: 'O campo contém caracteres não permitidos' })
 */
export function noXssPatterns(value: string): boolean {
  return !XSS_PATTERN.test(value)
}
